<template>
  <modal @close="closeRegModal" :isRegistration="true" :isRegistrationDesktop="true" :click_outside="false">
    <p class="text-white font-bold text-xl top-font -mt-4" slot="header">Запись в резерв</p>

    <div class="pb-5 text-sm font-semibold text-main-text">

      <!--
                  <div class = "text-center text-mxs mb-4">
                      <p><span class="text-brand-light">Вы регистрируетесь в резерв!</span><br>
                          После регистрации вам необходимо дождаться<br> от нас уведомления,
                          что места появились,<br> и можно приходить</p>
                  </div> -->
      <div class="mx-6 mb-6 font-normal">
        <div class="mb-2">
          <img class="h-4 w-4 mr-2" src="@/assets/SVG/calendar-light.svg"> <span
            class="align-text-top">{{ getEventDate }}</span>
        </div>
        <div>
          <img class="h-4 w-4 mr-2" src="@/assets/SVG/place.svg"> <span class="align-text-top">{{ event.place }}</span>
        </div>
      </div>
      <p class="text-mxs text-additional-text ml-6 mx-5 mt-6 -mb-2 cursor-default" v-if="!newTeam">Название команды</p>
      <p class="text-mxs text-additional-text ml-6 mx-5 -mb-2 cursor-default" v-if="newTeam">Создать команду</p>
      <div class="flex mr-auto selector mt-2 ml-6 justify-center border-transparent mx-5">
        <select-box placeholder="Выберите команду"
                    class="font-bold text-additional-text"
                    :listItems="teamList"
                    @input="setValue($event)"
                    :value="teamName"
                    @newTeamCreate="newTeam = true"
                    @hideTeamCreate="newTeam = false; /*teamForm.name = ''*/"
                    :withTeamCreate="true"
                    :teamCreatingIsDisabled="teamList.length>=maxTeams || selected_team"
                    :selected_team="selected_team"
        >
        </select-box>
      </div>
      <span v-if="form.errors.has(`team_id`)" class="text-red text-xs font-normal ml-6"
            v-text="form.errors.first(`team_id`)"></span>

      <div class="mx-5 relative text-additional-text">
        <div class="my-4">
          <moz-input v-if="newTeam"
                     v-model="teamForm.name"
                     type="text"
                     placeholder="Название команды"
                     class="-mt-1"
                     :error="teamForm.errors.first('name')"
          >
          </moz-input>
          <moz-input v-model="form.captain_name"
                     type="text"
                     placeholder="Имя"
                     class=""
                     :error="form.errors.first('captain_name')"
          >
          </moz-input>
          <moz-input v-model="form.captain_phone"
                     type="tel"
                     inputmode="tel"
                     placeholder="Телефон для связи"
                     class="pt-2"
                     :error="form.errors.first('captain_phone')"
          >
          </moz-input> <!--
                      <moz-input v-model="form.captain_email"
                            type="email"
                            placeholder="E-mail"
                            class="pt-2"
                            :error="form.errors.first('captain_email')"
                            >
                    </moz-input> -->
          <moz-input v-model="form.comment"
                     type="text"
                     ref="name"
                     placeholder="Комментарий"
                     class="pt-2"
          >
          </moz-input>
          <!-- <input  class="border-brand font-semibold mb-8 w-full pl-1 pb-1 text-main-text "
                  v-model="form.captain_name"
                  type="name"
                  ref="name"
                  readonly
                  >
                  <img    src="@/assets/SVG/pencil.svg"
                          class = "h-4 mr-1 pin-r absolute cursor-pointer"
                          refName = "name"
                          >
          <input  class="border-brand font-semibold mb-8 w-full pl-1 pb-1 text-main-text"
                  placeholder="Телефон"
                  type="phone"
                  ref="tel"
                  readonly
                  v-model="form.captain_phone" >
                  <img
                        src="@/assets/SVG/pencil.svg"
                        refName = "tel"
                        class = "h-4 mr-1 pin-r absolute  cursor-pointer">
          <input  class="border-brand font-semibold mb-8 w-full pl-1 pb-1 text-main-text"
                  placeholder="Email"
                  type="email"
                  ref="email"
                  readonly
                  v-model="form.captain_email">
                  <img
                        src="@/assets/SVG/pencil.svg"
                        class = "h-4 mr-1 pin-r absolute  cursor-pointer"
                        refName = "email">
          <input class="border-brand font-semibold mb-8 w-full pl-1 pb-1  text-main-text "
                  v-model="form.comment"
                  type="comment"
                  placeholder="Комментарий"> -->
        </div>
      </div>
      <plus-minus-counter class="px-10 lg:px-5" :max="event.max_team_players" v-model="form.player_count"
                          :min="min_player_count"></plus-minus-counter>
      <div class="mx-5 text-center justify-start flex items-center mt-2 font-normal"
           v-if="form.errors.has('player_count')">
        <img src="@/assets/SVG/error_notification.svg" alt="error">
        <span class="text-mxs ml-1 text-brand-red" v-text="form.errors.first('player_count')"></span>
        <p v-if="teamValue===null" class="flex w-full justify-center">1</p>
      </div>
      <p v-if="form.player_count===null" class="flex w-full justify-center">1</p>


      <p class="ml-5 mt-6 text-sm">К оплате: <span class="text-brand-light"
                                                   v-text="`${countSumm} ${event.currency || 'RUB'}`"></span></p>


      <div class="flex justify-start items-end my-6 ml-5">
        <label class="flex justify-start mt-1 cursor-pointer text-mxs">
                    <span class="mr-3">
                        <input class="checkbox" :checked="form.play_for_first_time" v-model="form.play_for_first_time"
                               @click="$emit('selectTeam')" type="checkbox">
                        <span class="checkbox-custom"></span>
                    </span> <span class="pt-1">Мы играем в первый раз</span>
        </label>
      </div>

      <div class="flex mb-2">
        <button class="rezerv text-white flex-grow mx-5 py-3 font-semibold cursor-pointer" @click="closeReg">
          Записаться в резерв
        </button>
      </div>

      <user-data-change-q v-if="userdata_change_q"
                          @close="userdata_change_q = false"
                          @agree="allowMod(); userdata_change_q = false"
                          @notAgree="userdata_change_q = false"></user-data-change-q>
    </div>
  </modal>

</template>

<script>
import ru from 'date-fns/locale/ru';
import format from 'date-fns/format';
import ModalMixin from '@/mixins/modals';
import Modal from '@/views/modals/base-modal';
import SelectBox from '@/views/partners/selectbox';
import client from '@/clients/player';
import { mapActions, mapState } from 'vuex';
import Form from 'form-backend-validation';
import UserDataChangeQ from '../without-online-pay/userdata-change-q';
import PlusMinusCounter from '../../components/plus-minus-counter.vue';

export default {
  name: 'Participate',
  components: {
    Modal,
    SelectBox,
    UserDataChangeQ,
    PlusMinusCounter,
  },
  props: ['thanks', 'participate', 'event', 'user_events', 'city_id'],
  mixins: [ModalMixin],
  data() {
    return {
      min_player_count: this.city_id === 6 ? 1 : 2,
      form: new Form({
        event_day_id: this.event.uuid,
        team_id: '',
        // captain_email: '',
        comment: '',
        captain_phone: '',
        player_count: this.city_id === 6 ? 1 : 2,
        captain_name: '',
        play_for_first_time: false,
      }, { http: client }),
      teamForm: new Form({
        name: '',
      }, { http: client }),
      ext: '',
      show: true,
      teamSetup: '',
      teamName: '',
      teamValue: 2,
      rezerv: false,
      loaded: false,
      vale: this.thanks,
      teamList: [],
      tempTeamList: [
        {
          name: 'коты',
          key: 1
        },
        {
          name: 'псы',
          key: 2
        },
        {
          name: 'хомяки',
          key: 3
        }],

      userdata_change_q: false,
      refName: '',
      newTeam: false,
      newTeamName: '',
      maxTeams: 10,
      selected_team: false,
    };
  },

  watch: {
    teamValue() {
      this.form.player_count = this.teamValue;
    },

    count() {
      if (this.teamValue === 1 || 5 || 6 || 7 || 8 || 9 || 10) {
        this.count = 'человек';
      } else {
        this.count = 'человека';
      }
    },

    teamSetup() {
      return this.teamSetup;
    },
    formWatcher() {
      if (this.formWatcher) {
        if (this.$metrika) {
          this.$metrika.reachGoal('offline-reg-fields-filled');
        }
      }
    },
  },
  created() {
    this.loaded = true;
    this.fetchTeams();
    Object.keys(this.form)
        .forEach((item) => {
          if (this.user[item]) {
            this.form[item] = this.user[item];
          }
        });
    this.form.captain_name = this.user.name;
    this.form.captain_email = this.user.email;
    this.form.captain_phone = this.user.phone;
    if (this.$metrika) {
      this.$metrika.reachGoal('offline-reg-form-opened');
    }
  },
  computed: {
    user() {
      return this.$store.getters.userInfo;
    },
    countSumm() {
      console.dir(this.event);
      return this.form.player_count * this.event.price / 100;
    },

    getEventDate() {
      const dates = [];
      dates.push(format(this.event.played_at, 'DD MMMM, dd', { locale: ru }));
      return dates[0];
    },

    gameInfo() {
      const date = format(this.event.played_at, 'DD.MM', { locale: ru });
      const name = this.event.game_topic ? `«${this.event.game_topic}»` : `«${this.event.game_type}»`;
      return `${date} в ${this.event.time} в ${this.event.place} ${name}`;
    },
    formWatcher() {
      if (this.form.captain_name !== '' && this.form.captain_phone !== '' && this.form.team_id !== '') {
        return true;
      }
    },
  },
  methods: {
    ...mapActions(['refreshUser']),

    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
    closeReg() {
      this.form.post('/applications')
          .then((response) => {
            this.refreshUser(client);
            if (this.$metrika) {
              this.$metrika.reachGoal('offline-reg');
            }
            if (this.formWatcher) {
              if (this.$metrika) {
                this.$metrika.reachGoal('offline-reg-submitted');
              }
            }
            this.$emit('thanks');
            this.vale = !this.vale;
          });
    },
    fetchTeams() {
      let route = `/teams?city_id=${this.city_id}`;
      const line_events = this.user_events.filter(item => item.event_record_id === this.event.event_record_id);
      if (this.city_id) {
        route = `/teams?filter[city_id]=${this.city_id}&city_id=this.city_id`;
      }
      client.get(route)
          .then(({ data: teams }) => {
            if (line_events.length) {
              this.teamList = teams.filter(item => item.id === line_events[0].team_id);
              this.selected_team = true;
              // this.teamName = this.teamList[0].name;
              // this.form.team_id = this.teamList[0].id;
              return;
            }
            this.teamList = teams;
          });
    },
    setValue(val) {
      this.teamName = val;
      this.form.team_id = this.teamList[val].id;
    },

    onEditFieldClick(event) {
      if (event.target.tagName !== 'IMG') {
        return;
      }
      this.refName = event.target.getAttribute('refName');
      this.userdata_change_q = true;
    },

    allowMod() {
      const ref = this.refName;
      const target = this.$refs[ref];
      target.removeAttribute('readonly');
    },
    closeRegModal() {
      if (this.formWatcher) {
        if (this.$metrika) {
          this.$metrika.reachGoal('offline-reg-declined');
        }
      }
      this.$emit('close');
    },
  },
};

</script>

<style scoped>

.selector {
  width: 263px;
  height: 38px;
  background-color: #e3e3e3;
  border-radius: 20px;
}

.team-bg-left {
  background-color: #bd006c;
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
}

.team-bg-right {
  background-color: #bd006c;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}

.border-brand {
  outline: none;
  border-bottom-color: #979797 !important;
  border-top: none;
  border-left: none;
  border-right: none;
  border-width: 1px;
}

input[type=range] {
  -webkit-appearance: none;
  margin: 18px 0;
  width: 100%;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  animate: 0.2s;
  background: #550045;
}

input[type=range]::-webkit-slider-thumb {
  box-shadow: 1px 1px 1px #bd006c, 0px 0px 1px #bd006c;
  border: 1px solid #bd006c;
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background: #bd006c;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -9px;
  margin-bottom: -9px;
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: #550045;
}

input[type=range]::-moz-range-track {
  width: 100%;
  height: 1.4px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  background: #550045;
  border-radius: 1.3px;
  border: 0.2px solid #550045;
}

input[type=range]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  border: 1px solid #550045;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #550045;
  cursor: pointer;
}

input[type=range]::-ms-track {
  width: 100%;
  height: 1.4px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
}

input[type=range]::-ms-fill-lower {
  background: #550045;
  border: 0.2px solid #550045;
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
}

input[type=range]::-ms-fill-upper {
  background: #550045;
  border: 0.2px solid #550045;
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
}

input[type=range]::-ms-thumb {
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  border: 1px solid #550045;
  height: 20px;
  width: 20px;
  border-radius: 3px;
  background: #550045;
  cursor: pointer;
}

input[type=range]:focus::-ms-fill-lower {
  background: #550045;
}

input[type=range]:focus::-ms-fill-upper {
  background: #550045;
}

.rezerv {
  width: 100%;
  border-radius: 28px;
  border: 1px solid rgba(151, 151, 151, 0);
  background-color: #bd006c;
  outline: none;
}

.checkbox {
  display: none;
}

.checkbox-custom {
  position: relative;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 3px;

}

.checkbox-custom,
.label {
  display: inline-block;
  vertical-align: middle;
  @apply text-xs
}

.checkbox:checked + .checkbox-custom::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 2px;
  outline: 2px solid #979797;

  background-image: url("../../../../assets/SVG/modal-tick.svg");
  background-size: 0.9rem;
  background-position: center;

  background-repeat: no-repeat;
  color: #bd006c;
  font-weight: bold;
}


input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #979797;
  opacity: 1;
}

input[readonly] {
  cursor: default;
}


</style>
